import {ErrorState} from 'presentation/components';
import {LayoutContainer} from 'presentation/pages/private/my-hospitalization/components/LayoutContainer';
import {LoadingSkeleton} from 'presentation/pages/private/my-hospitalization/components/LoadingSkeleton';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {EmptySearchState} from 'presentation/pages/private/my-hospitalization/components/EmptySearchState';
import {EmptyStateHospitalization} from 'presentation/pages/private/my-hospitalization/components/EmptyState';
import {ActionTypeLoggingAccessEnum} from 'domain/usecases/private/my-hospitalization/post-logging-access';
import {useMyHospitalizationLoggingAccess} from 'presentation/pages/private/my-hospitalization/hooks/useMyHospitalizationLoggingAccess';
import {filters} from '../../constants/examsFilters';
import {tabs} from '../../constants/examsTabs';
import {useResultsReleased} from '../../hooks/useResultsReleased';
import {ExamDrawer} from '../ExamDrawer';
import {ExamCardsGrid} from '../ExamsCardsGrid';
import {HeaderFilterExams} from '../HeaderFilterExams';

const {empty, error, searchEmpty, titleListFilter} =
	translations['pt-br'].privateFlow.myHospitalization.exams;

export const ResultsReleased = () => {
	useMyHospitalizationLoggingAccess(ActionTypeLoggingAccessEnum.EXAMS_RESULTS);
	const {data, isEmpty, isEmptyFiltered, isError, isLoading, refetch, clearSearch} =
		useResultsReleased();

	if (isLoading) {
		return (
			<LayoutContainer tabs={tabs}>
				<HeaderFilterExams
					listDrawerItens={filters}
					titleListDrawer={titleListFilter}
					count={data.length}
				/>
				<LoadingSkeleton />
			</LayoutContainer>
		);
	}

	if (isError) {
		return (
			<LayoutContainer tabs={tabs}>
				<ErrorState
					title={error.title}
					description={error.description}
					handleRefresh={refetch}
				/>
			</LayoutContainer>
		);
	}

	if (isEmpty) {
		return (
			<LayoutContainer tabs={tabs}>
				<EmptyStateHospitalization
					iconName="clipboard-plus-outline"
					title={empty.title}
					description={empty.description}
				/>
			</LayoutContainer>
		);
	}

	if (isEmptyFiltered) {
		return (
			<LayoutContainer tabs={tabs}>
				<HeaderFilterExams
					listDrawerItens={filters}
					titleListDrawer={titleListFilter}
					count={data.length}
				/>
				<EmptySearchState
					title={searchEmpty.title}
					description={searchEmpty.description}
					clearFilter={clearSearch}
				/>
			</LayoutContainer>
		);
	}

	return (
		<LayoutContainer tabs={tabs}>
			<HeaderFilterExams
				listDrawerItens={filters}
				titleListDrawer={titleListFilter}
				count={data.length}
			/>
			<ExamCardsGrid list={data} />
			<ExamDrawer />
		</LayoutContainer>
	);
};
